<div class="modal-header">
  <h4 class="modal-title d-flex align-items-baseline" style="min-width: 0">
    <span>Labels</span>
    @if (hasSelection()) {
      <small class="text-muted ms-1">&mdash;</small>
      @if (selectedDatasets.length === 1) {
        <small
          class="text-muted ms-1 text-truncate"
          style="max-width: 20rem; min-width: 0"
          [title]="selectedDatasets[0].name">
          {{ selectedDatasets[0].name }}
        </small>
      }
      @if (selectedDatasets.length > 1) {
        <small class="text-muted ms-1">{{ selectedDatasets.length }} files selected</small>
      }
    }
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>

<div class="modal-body pb-2">
  @if (rows.length === 0) {
    <div class="text-muted">No labels yet.</div>
  }

  @if (rows.length > 0) {
    <table class="table table-sm align-middle mb-0">
      <tbody>
        @for (row of rows; track row.label.labelId) {
          <tr>
            @if (hasSelection()) {
              <td style="width: 2.5rem">
                <input
                  type="checkbox"
                  class="form-check-input"
                  [checked]="row.selection === 'checked'"
                  [indeterminate]="row.selection === 'indeterminate'"
                  (change)="toggleRow(row)" />
              </td>
            }
            <td>
              <ch-label-pill [label]="row.label"></ch-label-pill>
            </td>
            <td class="text-end" style="width: 12rem">
              <button type="button" class="btn btn-sm btn-outline-secondary me-1" (click)="openEditLabel(row)">
                Edit
              </button>
              <button type="button" class="btn btn-sm btn-outline-danger" (click)="deleteLabel(row)">Delete</button>
            </td>
          </tr>
        }
      </tbody>
    </table>
  }

  @if (rows.length > 1) {
    <div class="text-end mt-2">
      <button type="button" class="btn btn-sm btn-outline-danger" [disabled]="saving" (click)="deleteAllLabels()">
        Delete all
      </button>
    </div>
  }
</div>

<div class="modal-footer">
  <button
    type="button"
    class="btn btn-primary me-auto"
    [disabled]="sessionData.labelsMap.size >= maxLabelsPerSession"
    [title]="
      sessionData.labelsMap.size >= maxLabelsPerSession
        ? 'Maximum ' + maxLabelsPerSession + ' labels per session reached'
        : ''
    "
    (click)="openCreateLabel()">
    + New label
  </button>
  @if (canApply()) {
    <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
  }
  <button
    type="button"
    class="btn"
    [ngClass]="{ 'btn-primary': canApply(), 'btn-secondary': !canApply() }"
    [disabled]="saving"
    (click)="confirm()">
    @if (canApply()) {
      <span>Apply</span>
    }
    @if (!canApply()) {
      <span>Close</span>
    }
  </button>
</div>
